"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _logger = require("@insided/shared/services/logger");

var _service = require("./service");

var _IpModal = _interopRequireDefault(require("./IpModal"));

require("./styles.scss");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var IpDetails = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(IpDetails, _PureComponent);

  var _super = _createSuper(IpDetails);

  function IpDetails() {
    var _this;

    (0, _classCallCheck2.default)(this, IpDetails);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      showIpModal: false,
      ipData: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getIpData", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this$props, authorId, publicReplyId, publicTopicId, ipData;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, authorId = _this$props.authorId, publicReplyId = _this$props.publicReplyId, publicTopicId = _this$props.publicTopicId;

              if (!(!publicReplyId && !publicTopicId)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              _context.prev = 3;
              _context.next = 6;
              return (0, _service.getIpData)(authorId, publicReplyId, publicTopicId);

            case 6:
              ipData = _context.sent;

              _this.setState({
                showIpModal: true,
                ipData: ipData
              });

              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);

              _logger.logger.error(_context.t0, {
                component: 'IpDetails',
                action: 'getIpData'
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 10]]);
    })));
    return _this;
  }

  (0, _createClass2.default)(IpDetails, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var authorName = this.props.authorName;
      var _this$state = this.state,
          showIpModal = _this$state.showIpModal,
          ipData = _this$state.ipData;
      return (0, _preact.h)("div", {
        className: "topic-moderation__ip-button"
      }, (0, _preact.h)("span", {
        onClick: this.getIpData,
        role: "button",
        tabIndex: 0,
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();

            _this2.getIpData();
          }
        }
      }, "View IP details"), showIpModal && ipData && (0, _preact.h)(_IpModal.default, {
        authorName: authorName,
        ipData: ipData,
        onClose: function onClose() {
          return _this2.setState({
            showIpModal: false
          });
        }
      }));
    }
  }]);
  return IpDetails;
}(_preactCompat.PureComponent);

var _default = IpDetails;
exports.default = _default;